import {
  colorCss,
  fontSizeCss,
  mobileColorCss,
  mobileFontSizeCss,
} from 'common/utils/styleUtilsNew'
import { css, styled } from 'styled-components'
import { FormInterface } from '../form.schema'

export interface FormSuccessOptInScreenTextUiStylesInterface
  extends Pick<
    FormInterface['action']['successOptInScreen'],
    'textColor' | 'mobileTextColor'
  > {
  fontSize?: number
  mobileFontSize?: number
  color?: string
  mobileColor?: string
}

export const FormSuccessOptInScreenTextUi = styled.span<FormSuccessOptInScreenTextUiStylesInterface>`
  
  margin-top: 16px;

  word-break: break-word;

  ${fontSizeCss}
  ${colorCss}

  ${p => p.theme.phone} {

    ${mobileFontSizeCss}
    ${mobileColorCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`

    ${mobileFontSizeCss}
    ${mobileColorCss}
  `}
`
